/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Loading({
  children,
  viewPath = "/App/ChooseUser/Users/Loading"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Loading.Text"
  data-view-path={viewPath}
 className="views-text"
>
Loading...
</span>
{children}
</React.Fragment>)
}